import styled from "styled-components";

import themes from "~/themes";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  margin-top: ${({ marginBottom }) => (marginBottom ? marginBottom : "5%")};
  margin-bottom: 2%;
  position: relative;

  label {
    font-size: 12px;
    color: ${(props) =>
      props.isFocus ? themes.colors.orange.n2 : themes.components.colors.label};
  }

  input {
    padding-left: ${(props) => (props.hasLeftIcon ? "38px" : "10px")};
    padding-right: 35px;
    font-size: 16px;
    border-width: 1px;
    border-style: solid;
    border-color: ${(props) =>
      props.isFocus ? themes.colors.orange.n2 : "#444444"};

    color: ${themes.components.colors.input};
    height: 45px;
    background: ${themes.colors.white.n5};
    border-radius: 7px;
  }

  .icon {
    position: absolute;
    max-width: 18px;
    right: 10px;
    top: 34px;
    cursor: pointer;
  }
`;

export const LeftIcon = styled.div`
  position: absolute;
  left: 12px;
  top: 34px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1;

  svg {
    width: 16px;
    height: 16px;
  }
`;

export const ErrorText = styled.span`
  font-size: 12px;
  color: ${themes.components.colors.messageError};
  margin-top: 2px;
`;